import ConfirmDeletePageModal from './ConfirmDeletePageModal.container';

export default ConfirmDeletePageModal;
